import React, { Fragment, useState } from 'react';
import { css, StyleSheet } from 'aphrodite';
import Grid from '@material-ui/core/Grid';
import moment from 'moment-timezone'
import { Tooltip } from '@material-ui/core';
import { Doughnut } from 'react-chartjs-2';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { Stats } from '../../components/Stats';
import { AppUiHelper } from '../../helpers/AppUiHelper';
import { AppStyles, AppTheme } from '../../styles/AppTheme';
import { StackedBarChartDialog } from '../../common/components/charts/StackedBarChartDialog';
import { GraphHelper } from '../../common/components/charts/GraphHelper';
import { AppHelper } from '../../helpers/AppHelper';
import { DateRangePicker } from '../../common/components/charts/DateRangePicker';
import { GraphUiHelper } from '../../helpers/GraphUiHelper';
import { formatDpName, getDownloadDeviceActivityFieldDef, graphColorsForEachAdTypes } from '../../data/data';
import { GraphDialog } from '../../common/components/charts/GraphDialog';
import { SearchBar } from '../../common/components/SearchBar';
import { Toast } from '../../components/Toast';
import { DynamicFormDialog } from '../../common/components/DynamicFormDialog';
import { Controller } from '../../common/Controller';
import { ApiHelper } from '../../common/helpers/ApiHelper';
import { AppConfig } from '../../AppConfig';

export class DpsActivity extends BaseEntityPage {
  pageKey = 'DpsActivity';
  pageTitle = Helper.getString('exchangeReports');
  orgId = this.props.match.params.orgId || 'PRODUCT';
  breadCrumbs = [
    { title: Helper.getString('home'), to: this.baseRoute() },
    { title: Helper.getString('exchangeReports') },
  ];
  noAdd = true;
  state = {
    dateStart: moment().subtract(30, 'day').format('YYYY-MM-DD'),
    dateEnd: moment().subtract(1, 'day').format('YYYY-MM-DD'),
    stats: [],
    items: [],
    searchText: '',
    viewMode: 'all',
    inProcessSearch: false,
    showToast: false,
    severity: 'info',
    toastMsg: '',
    showDownloadPerDeviceDialog:false,
  };

  exportConfig = {
    headers: {},
    format: 'xlsx'
  }

  constructor(props, options) {
    super(props, options);
    this.chartOptions = GraphHelper.getdoughnutChartOptions()
    this.lineChartOptions = GraphHelper.getLineChartOptions()
    this.noTableHead = true
    this.tableHeadersMap = {
      Index: (current) => {
        return (
          <span className={css(Styles.indexStyle)}>{current.__index + 1}</span>
        )
      },
      Venue: (current) => GraphUiHelper.getVenueInfo(current),
      Info: (current) => {
        return (
          GraphUiHelper.getExchangesOverallData(current)
        )
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap);
    this.toFetch = this.makeFetches();
    this.headerActions = [
      {
        label: 'Download',
        onClick: () => this.onExport()
      },
      {
        label: 'Download per Screen per Hour',
        onClick: () => this.setState({ showDownloadPerDeviceDialog: true })
      }
    ];
  }

  onExport = () => {
    if (!this.exportConfig || !this.exportConfig.headers || Object.keys(this.exportConfig.headers).length === 0) {
      this.onError(Helper.getString('invalidDownload'));
      return;
    }

    const DwnldUtil = require('../../common/helpers/FileDownloader');
    const fileName = this.makeFileName();
    const rows = this.prepExcelDownload();

    DwnldUtil.FileDownloader.exportAsExcelFile(rows, fileName);
  }

  makeFetches = () => {
    const { dateStart, dateEnd, viewMode, searchText } = this.state;
    const queryParams = {}

    if (dateStart) queryParams.startPeriod = dateStart.replaceAll('-', '')
    if (dateEnd) queryParams.endPeriod = dateEnd.replaceAll('-', '')

    if (viewMode === 'device' && searchText) {
      queryParams.venueCodesStr = [searchText.trim()]
      return [{ method: 'GET', paths: ['miscs', 'deviceactivity'], queryParams }];
    }

    queryParams.groupId = this.orgId
    return [{ method: 'GET', paths: ['miscs', 'dpactivity'], queryParams }];
  };

  onError = (toastMsg) => {
    this.setState({
      showToast: true,
      severity: 'error',
      toastMsg
    });
  }

  getToast = () => {
    return (
      <Toast
        open={this.state.showToast}
        severity={this.state.severity}
        message={this.state.toastMsg}
        handleClose={() => this.setState({ showToast: false })}
      />
    )
  }

  processDeviceActivityData = (result) => {
    const labels = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23']
    const chartTitle = 'Heartbeat By Hour'

    for (const item of result.items) {
      item.hbGraphData = GraphHelper.generateLineGraphData({ chartTitle, labels, data: item.statusByHour })
    }
    result.dpChartsData = this.generateDeviceDoughNutData(result)
    return result
  }

  generateDeviceDoughNutData(result) {
    const dp = {}
    for (const key in result.stats) {
      const splitArr = key.split('_')
      if (splitArr.length !== 2) continue
      if (!dp[splitArr[1]]) dp[splitArr[1]] = {}
      dp[splitArr[1]][key] = result.stats[key]
    }

    const dpChartsData = []
    for (const key in dp) {
      const chartTitle = formatDpName(key)
      const labelsWithoutCounter = ['POP', 'GET', 'LEASED', 'ERROR']
      const data = []
      const labels = []

      for (const label of labelsWithoutCounter) {
        let value = 0;
        if (label === 'POP') data.push(dp[key]['totalPop_' + key] || 0), value = AppHelper.formatNumberStats(dp[key]['totalPop_' + key] || 0)
        if (label === 'GET') data.push(dp[key]['totalGet_' + key] || 0), value = AppHelper.formatNumberStats(dp[key]['totalGet_' + key] || 0)
        if (label === 'LEASED') data.push(dp[key]['totalAds_' + key] || 0), value = AppHelper.formatNumberStats(dp[key]['totalAds_' + key] || 0)
        if (label === 'ERROR') data.push(dp[key]['totalErr_' + key] || 0), value = AppHelper.formatNumberStats(dp[key]['totalErr_' + key] || 0)
        labels.push(`${label} (${value})`)
      }

      if (data.every(d => d === 0)) continue
      dpChartsData.push(GraphHelper.generateDoughNutGraphData({ chartTitle, labels, data }))
    }
    return dpChartsData
  }

  generateDeviceDoughNutDataForVenue(current) {
    const dp = {}
    const latestError = {}

    for (const key in current) {
      if (key.startsWith('latestErr_')) {
        const code = key.split('_')[1]
        latestError[code] = { code, error: current[key] }
      }
      const splitArr = key.split('_')
      if (splitArr.length !== 2) continue
      if (!dp[splitArr[1]]) dp[splitArr[1]] = {}
      dp[splitArr[1]][key] = current[key]
    }

    const dpChartsData = []
    for (const key in dp) {
      const chartTitle = formatDpName(key)
      const labelsWithoutCounter = ['POP', 'GET', 'LEASED', 'ERROR']
      const data = []
      const labels = []

      for (const label of labelsWithoutCounter) {
        let value = 0;
        if (label === 'POP') data.push(dp[key]['pop_' + key] || 0), value = AppHelper.formatNumberStats(dp[key]['pop_' + key] || 0)
        if (label === 'GET') data.push(dp[key]['get_' + key] || 0), value = AppHelper.formatNumberStats(dp[key]['get_' + key] || 0)
        if (label === 'LEASED') data.push(dp[key]['ads_' + key] || 0), value = AppHelper.formatNumberStats(dp[key]['ads_' + key] || 0)
        if (label === 'ERROR') data.push(dp[key]['err_' + key] || 0), value = AppHelper.formatNumberStats(dp[key]['err_' + key] || 0)
        labels.push(`${label} (${value})`)
      }

      if (data.every(d => d === 0)) continue
      dpChartsData.push(GraphHelper.generateDoughNutGraphData({ chartTitle, labels, data, latestError }))
    }
    return dpChartsData
  }

  onFetchSuccess = (results) => {
    const { viewMode } = this.state;

    const statusInfo = AppUiHelper.getDaStatsInfo()
    const pStats = []
    for (const [key, value] of Object.entries(results[0].stats || {})) {
      if (!statusInfo[key]) continue
      pStats.push({
        title: statusInfo[key].title,
        value: AppHelper.formatNumberStats(value || 0),
        image: statusInfo[key].image,
        order: statusInfo[key].order
      })
    }

    if (viewMode === 'device') {
      const pResult = this.processDeviceActivityData(results[0])
      const processedItems = AppHelper.processVenueItemsFromDa(pResult.items)

      this.setState({
        stats: Helper.sortDictArray(pStats),
        items: processedItems.reverse(),
        dpChartsData: pResult.dpChartsData,
        inProcessSearch: false,
      },()=>this.configureDownloadForCurrentView({viewMode:'device',items:this.state.items}));
      return;
    }

    const { hourlyData } = this.processData(results[0])
    this.setState({
      stats: Helper.sortDictArray(pStats),
      items: results[0].items.reverse(),
      dpChartsData: results[0].dpChartsData,
      inProcessSearch: false,
      hourlyData
    },()=>this.configureDownloadForCurrentView({viewMode:'all',items: hourlyData}));
  };

  onSearch = async (searchText) => {
    const trimmed = (searchText || '').trim()
    const { dateStart, dateEnd } = this.state;
    const start = moment(dateStart)
    const end = moment(dateEnd)

    if (end.diff(start, 'days', true) > 30) {
      this.onError(Helper.getString('dateRangeExceededForDpsReport'))
      return
    }

    if (!trimmed) {
      this.setState(
        { searchText: '', viewMode: 'all', inProcessSearch: true },
        () => {
          this.toFetch = this.makeFetches();
          this.fetchItems();
        }
      )
      return
    }

    if (trimmed.includes(',')) {
      this.onError(Helper.getString('deviceActivitySearchError'))
      return
    }

    this.setState(
      { searchText: trimmed, viewMode: 'device', inProcessSearch: true },
      () => {
        this.toFetch = this.makeFetches();
        this.fetchItems();
      }
    )
  }

  processData = (result) => {
    const { dpChartsData, dp } = this.generateDataForDoughNutGraph(result)
    result.dpChartsData = dpChartsData
    const exchanges = Object.keys(dp)
    const hourlyData = [];
    for (const item of result.items) {
      for (let hour = 0; hour < 24; hour++) {
        const row = { period: item.period, hour };
        row.cmsPop = item.day_cmsPop[hour] || 0;
        exchanges.forEach(exchange => {
          row[`get_${exchange}`] = item[`day_get_${exchange}`] && item[`day_get_${exchange}`][hour] || 0;
          row[`lsd_${exchange}`] = item[`day_get_${exchange}`] && item[`day_ads_${exchange}`][hour] || 0;
          row[`err_${exchange}`] = item[`day_get_${exchange}`] && item[`day_err_${exchange}`][hour] || 0;
          row[`pop_${exchange}`] = item[`day_get_${exchange}`] && item[`day_pop_${exchange}`][hour] || 0;
        });

        hourlyData.push(row);
      }
    }
    // console.log('hrlyData', hourlyData)
    const headers = {
      period: 'period',
      hour: 'hour',
      cmsPop: 'cmsPop'
    }
    exchanges.forEach(exchange => {
      headers[`get_${exchange}`] = `get_${exchange}`
      headers[`lsd_${exchange}`] = `lsd_${exchange}`
      headers[`err_${exchange}`] = `err_${exchange}`
      headers[`pop_${exchange}`] = `pop_${exchange}`
    })
    console.log('headers', headers)
    this.exportConfig.headers = headers
    return { hourlyData }
  }

  generateDataForDoughNutGraph(result) {
    const dp = {}
    for (const key in result.stats) {
      const splitArr = key.split('_')
      if (splitArr.length !== 2) continue
      if (!dp[splitArr[1]]) dp[splitArr[1]] = {}
      dp[splitArr[1]][key] = result.stats[key]
    }
    const dpChartsData = []
    for (const key in dp) {
      const chartTitle = formatDpName(key)
      const labelsWithoutCounter = ['POP', 'GET', 'LEASED', 'ERROR']
      const data = []
      const labels = []
      for (const label of labelsWithoutCounter) {
        let value = 0;
        if (label === 'POP') data.push(dp[key]['totalPop_' + key] || 0), value = AppHelper.formatNumberStats(dp[key]['totalPop_' + key] || 0)
        if (label === 'GET') data.push(dp[key]['totalGet_' + key] || 0), value = AppHelper.formatNumberStats(dp[key]['totalGet_' + key] || 0)
        if (label === 'LEASED') data.push(dp[key]['totalAds_' + key] || 0), value = AppHelper.formatNumberStats(dp[key]['totalAds_' + key] || 0)
        if (label === 'ERROR') data.push(dp[key]['totalErr_' + key] || 0), value = AppHelper.formatNumberStats(dp[key]['totalErr_' + key] || 0)
        labels.push(`${label} (${value})`)
      }
      let allZero = true
      for (const d of data) {
        if (d !== 0) {
          allZero = false
          break
        }
      }
      if (allZero) continue
      dpChartsData.push(GraphHelper.generateDoughNutGraphData({ chartTitle, labels, data }))
    }
    return { dpChartsData, dp }
  }

  generateDataForStackedBarChartForVenue(dataItem) {
    const dp = {};

    // Organize data by type and metric
    for (const key in dataItem) {
      if (!key.startsWith('day_')) continue;

      const splitArr = key.split('_'); // ['day', 'get', 'PX']
      if (splitArr.length !== 3) continue;

      const type = splitArr[2];   // PX, VI, etc.
      if (type === 'D1' || type === 'DT') continue
      const metric = splitArr[1]; // get, lsd, pop, err

      if (!dp[type]) dp[type] = {};
      dp[type][metric] = dataItem[key]; // store the array
    }

    const dpChartsData = [];
    const labels = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'];
    const metricOrder = ['pop', 'get', 'ads', 'err']; // order we want

    for (const type in dp) {
      dpChartsData.push({
        chartTitle: formatDpName(type),
        labels,
        datasets: metricOrder
          .filter(metric => dp[type][metric]) // only include existing metrics
          .map(metric => {
            const displayMetric = metric === 'ads' ? 'leased' : metric === 'err' ? 'error' : metric;
            return {
              label: displayMetric.toUpperCase(),
              data: dp[type][metric],
              backgroundColor: this.pickBgColor(displayMetric),
              borderWidth: 0,
              stack: 'stack1',
            };
          }),
      });
    }
    dpChartsData.push({
      chartTitle: 'CMS',
      labels,
      datasets: [{
        label: 'CMSPOP',
        data: dataItem.day_cmsPop || [],
        backgroundColor: '#020BC3',
        borderWidth: 0,
        stack: 'stack1',
      }]
    })
    return dpChartsData;
  }

  pickBgColor(metric) {
    const colors = {
      pop: graphColorsForEachAdTypes.pop,
      get: graphColorsForEachAdTypes.get,
      leased: graphColorsForEachAdTypes.leased,
      error: graphColorsForEachAdTypes.error,
    };
    return colors[metric]
  }

  prepExcelDownload() {
    const rows = [];

    for (const item of this.state.dataToDownload) {
      const e = {};
      for (const hKey in this.exportConfig.headers) {
        e[this.exportConfig.headers[hKey]] = this.exportRowItemValue(hKey, item)
      }
      rows.push(e);
    }
    return rows
  }

  exportRowItemValue(key, current) {
    const serialNumber = current.latestDeviceFeed && current.latestDeviceFeed.serialnumber
      ? current.latestDeviceFeed.serialnumber
      : current.serialNumber

    switch (key) {
    case 'site.title':
      return current.site && current.site.title ? current.site.title : ''
    case 'site.address':
      return current.site && current.site.address ? current.site.address : ''
    case 'serialNumber':
      return serialNumber || ''
    case 'hf':
      return current.hf ? Helper.formatDate2({ utcTimestamp: current.hf, format: 'hh:mm a' }) : ''
    default:
      return super.exportRowItemValue(key, current)
    }
  }


  generateTableMap = (items = {}) => {
    const map = {};
    Object.keys(items).forEach((key) => {
      if (key !== 'id') {
        map[items[key]] = (current) => <div>{current[key]}</div>;
      }
    });
    return map;
  };

  onTableValue = (current, index) => {
    if (!this.tableHeaders[index]) return '';
    return this.tableHeadersMap[this.tableHeaders[index]](current);
  };

  onFilter = (filters) => {
    this.setState(
      { ...filters, inProcessSearch: true },
      () => {
        this.toFetch = this.makeFetches();
        this.fetchItems();
      }
    );
  };

  onDateChange = ({ dateStart, dateEnd }) => {
    this.setState({
      dateEnd,
      dateStart
    })
  }

orderExchangeDict = (dict) => {
  const metricOrder = ['get', 'lsd', 'pop', 'err', 'latestStrErr'];

  // Separate common keys
  const metricRegex = /^(get|lsd|pop|err|latestStrErr)_(\w+)$/;
  const commonKeys = [];
  // eslint-disable-next-line no-undef
  const exchanges = new Set();

  for (const key of Object.keys(dict)) {
    const match = key.match(metricRegex);
    if (!match) {
      commonKeys.push(key);
    } else if (match[1] === 'get') {
      // identify exchanges ONLY from get_XX
      exchanges.add(match[2]);
    }
  }

  const sortedExchanges = [...exchanges].sort(); // alphabetical

  // Build ordered object
  const ordered = {};

  // Add common first
  for (const key of commonKeys) {
    ordered[key] = dict[key];
  }

  // Add exchanges in order
  for (const ex of sortedExchanges) {
    for (const metric of metricOrder) {
      const key = `${metric}_${ex}`;
      if (dict[key] !== undefined) {
        ordered[key] = dict[key];
      }
    }
  }

  return ordered;
}

buildExportFromItems = ({ items, prefixes = [], baseKeys = [] }) => {
  const headers = {};

  for (let i = 0; i < baseKeys.length; i++) {
    headers[baseKeys[i]] = baseKeys[i] === '_ADDRESS' ? 'address' : baseKeys[i];
  }

  // eslint-disable-next-line no-undef
  const exchangesSet = new Set();
  // Loop through all items and collect exhchanges
  items.forEach(item => {
    Object.keys(item).forEach(key => {
      if (prefixes.some(p => key.startsWith(p))) {
        exchangesSet.add(key.split('_')[1])
      }
    });
  });

  console.log('exchangesSet', [...exchangesSet])
  const exchanges = [...exchangesSet]
  for(const ex of exchanges) {
    for(const prefix of prefixes) {
      headers[prefix + ex] = prefix === 'ads_' ? 'lsd_' + ex : prefix + ex // This is because ad_XX is the total number of leased ads
    }
  }
  // this.exportConfig.headers = this.orderExchangeDict(headers);
  this.exportConfig.headers = headers
  console.log('headers', headers)
  this.setState({ dataToDownload: items });
};

configureDownloadForCurrentView = ({ viewMode, items }) => {
  if (!items || items.length === 0) {
    this.exportConfig.headers = {};
    this.setState({ dataToDownload: [] });
    return;
  }

  if (viewMode === 'device') {
    this.buildExportFromItems({
      items,
      baseKeys: ['period', 'deviceTitle', 'deviceCode', '_ADDRESS', 'siteTitle', 'siteAddress', 'serialNumber', 'hf', 'noOfhrsOnline', 'cmsPop', 'adapireqs'],
      prefixes: ['get_', 'ads_', 'pop_', 'err_', 'latestStrErr_'],
    });
  } else {
    this.buildExportFromItems({
      items,
      baseKeys: ['period', 'hour', 'cmsPop'],
      prefixes: ['get_', 'lsd_', 'pop_', 'err_']
    });
  }
};

makeFileName = () => {
  const range = this.state.dateStart.replaceAll('-', '') + '-' + this.state.dateEnd.replaceAll('-', '');
  if (this.state.viewMode === 'device' && this.state.searchText) {
    return `device-exchange-reports-${this.state.searchText}-${range}`;
  }
  return `exchange-reports-${range}`;
}

submitDownloadPerDeviceJob = async (data) => {
  const { formData, caller } = data;
  const startPeriod = moment(formData.startPeriod).tz(AppConfig.DEFAULT_ZONEINFO).format('YYYYMMDD')
  const endPeriod = moment(formData.endPeriod).tz(AppConfig.DEFAULT_ZONEINFO).format('YYYYMMDD')
  const start = moment(formData.startPeriod);
  const end = moment(formData.endPeriod);
  if (end.diff(start, 'days') > 7) {
    caller.setState({
      fetchState: ApiHelper.State.ERROR,
      errMsg: Helper.getString('dateRangeExceededForDaReport'),
      success: false,
      message: Helper.getString('dateRangeExceededForDaReport'),
      inProcess: false
    });
    return;
  }
  const payload = {
    groupId: 'PRODUCT',
    action: formData.action,
    startPeriod,
    endPeriod
  };

  ApiHelper.call({
    method: 'POST',
    endPoint: ApiHelper.makeUrlPath(['jobs']),
    jsonBody: payload,
  }, (err, result) => {
    if (err) {
      const errorMessage = Helper.getErrorMsg(err);
      caller.setState({
        fetchState: ApiHelper.State.ERROR,
        errMsg: errorMessage,
        success: false,
        message: errorMessage,
        inProcess: false
      });
      return;
    }

    this.setState({ showDownloadPerDeviceDialog: false });
    Controller.get().pushRoute('/admin/jobs');
  });
};

  renderAboveTable = () => {
    const { items, stats } = this.state;
    return (
      <div className={css(Styles.renderAboveTable)}>
        <DateRangePicker
          buttonLabel={Helper.getString('filter')}
          hideFilterButton={this.options.pageForOrgType !== 'PARTNER' ? true : false}
          onFilter={this.onFilter}
          onDateChange={this.onDateChange}
          dateEnd={this.state.dateEnd}
          dateStart={this.state.dateStart}
        />
        <div className={css(Styles.searchContainer)}>
          <SearchBar
            hint={Helper.getString('deviceActivitySearchHint')}
            inProcessSearch={this.state.inProcessSearch || false}
            callSearchOnEmptyText={true}
            onSearch={this.onSearch.bind(this)}
            searchText={this.state.searchText}
            showRecentButtonText={'Search'}
          />
        </div>
        {this.state.showDownloadPerDeviceDialog &&  (
          <DynamicFormDialog
            customSubmit={this.submitDownloadPerDeviceJob}
            formDefinition={getDownloadDeviceActivityFieldDef().fieldDef}
            isOpen={this.state.showDownloadPerDeviceDialog}
            onClosed={() => this.setState({ showDownloadPerDeviceDialog: false })}
          />
        )}
        {this.getToast()}
        {stats && <Stats items={stats}></Stats>}
        {this.state.dpChartsData && this.state.dpChartsData.length > 0 &&
          <Grid className={css(Styles.chartsContainer)} container spacing={2}>
            {this.state.dpChartsData.map((x, index) => {
              if (!x.data.datasets[0].data || x.data.datasets[0].data.length === 0) return ''
              return (
                <Grid item key={'chart_' + index} className={css(Styles.eachChartHolder)} xs={12} md={4}>
                  <div className={css(Styles.chartOuterWrap)} >
                    <div className={css(Styles.chartBlock)} >
                      {x.chartTitle &&
                        <div className={css(Styles.chartTitle)}>{x.chartTitle}</div>
                      }
                      {x.hasDataMoreThanZero === false ?
                        <div className={css(Styles.noChartMessage)}>{Helper.getString('noChartDataMessage')}</div> :
                        <Doughnut className={css(Styles.chartCanvas)} data={x.data} options={this.chartOptions} width={100} height={100} />}
                    </div>
                  </div>
                </Grid>
              )
            })}
          </Grid>
        }
        {this.state.showVenueGraphs &&
          <StackedBarChartDialog
            isOpen={this.state.showVenueGraphs}
            title={this.state.current.period ? moment(this.state.current.period, 'YYYYMMDD').format('MMMM Do, YYYY') : 'Exchange Stats for a Day'}
            onClosed={() => this.setState({ showVenueGraphs: false })}
            fullWidth={true}
            stackedBarChartData={this.generateDataForStackedBarChartForVenue(this.state.current)}
          />
        }
        {this.state.viewMode === 'device' && this.state.showVenueGraphs &&
          <GraphDialog
            isOpen={this.state.showVenueGraphs}
            lineChartData={this.state.current.hbGraphData}
            lineChartOptions={this.lineChartOptions}
            title={(this.state.current && this.state.current.deviceCode) ? this.state.current.deviceCode : Helper.getString('venueInfo')}
            onClosed={() => this.setState({ showVenueGraphs: false })}
            fullWidth={true}
            doughnutChartData={this.generateDeviceDoughNutDataForVenue(this.state.current)}
          />
        }
      </div>
    );
  };

  onActions = (current) => {
    const actions = []

    actions.push(
      <Tooltip title='Details' placement='top-start' key={current.id + 'Preview'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <img className={css(Styles.actionIconImage)} src={require('../../assets/icons/eye.svg')} onClick={() => { this.setState({ showVenueGraphs: true, current }) }} />
        </span>
      </Tooltip>
    )
    return actions
  }
}

const Styles = StyleSheet.create({
  statsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5
  },
  searchContainer:{
    width:'100%'
  },
  statsInnerContainer: {
    display: 'flex',
    gap: 15,
    borderBottom: '1px solid #d7d7d7b5',
    padding: '5px 0px',
    width: 'max-content'
  },
  dpText: {
    fontWeight: 'bold',
    backgroundColor: '#f5f5f5',
    padding: '3px 6px',
    borderRadius: 4,
    minWidth: 20,
    textAlign: 'center'
  },
  statsValueText: {
    backgroundColor: '#f5f5f5',
    padding: '3px 6px',
    borderRadius: 4,
    minWidth: 20,
    textAlign: 'center'
  },
  statsValues: {
    display: 'flex',
    alignItems: 'center',
    gap: 10
  },
  venueColumn: {
    display: 'flex',
    gap: 7,
    flexDirection: 'column'
  },
  spanValue: {},
  img: {
    height: 30,
  },
  line2: {
    fontSize: 12,
  },
  renderAboveTable: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 10
  },
  circleFill: {
    width: 18,
    height: 18,
    borderRadius: '50%',
  },
  fullWidth: {
    width: '100%',
  },
  mainContainer: {
    backgroundColor: AppTheme.primaryBg,
    width: '100%',
    '@media (max-width: 1025px)': {
      width: '97vw !important'
    }
  },
  eachChartHolder: {
  },
  eachChartHolder2: {
    width: '100%'
  },
  chartsContainer: {
    marginTop: '5px 0px',
    margin: '15px 0px',
    width: '100%',
  },
  chartOuterWrap: {
    background: '#fff',
    height: 214,
    borderRadius: 16
  },
  chartOuterWrap2: {
    background: '#fff',
    borderRadius: 16
  },
  chartBlock: {
    borderRadius: 16,
    padding: '10px 10px 10px 10px',
    height: 160
  },
  chartTitle: {
    fontSize: 16,
    color: '#121212',
    padding: 4
  },
  chartCanvas: {
    marginBottom: 10
  },
  statsHolder: {
    padding: '0 10px'
  },
  noChartMessage: {
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
    flexDirection: 'column',
    textAlign: 'center'
  }
});



// WEBPACK FOOTER //
// ./src/screens/admin/DpsActivity.js